import { Group, Stack } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconPlus } from "@tabler/icons-react"
import { getPaginationRowModel, SortingState } from "@tanstack/react-table"
import type { FAQ } from "@tfg/db"
import { Button, DEFAULT_PAGE_SIZE } from "@tfg/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { CustomTable } from "~/components/table/CustomTable"

import { FAQCreationModal } from "./FAQCreationModal"
import { FAQEditionModal } from "./FAQEditionModal"
import { useColumns } from "./columns"

type Props = {
  faqs: FAQ[]
}
export const FAQAdmin = ({ faqs }: Props) => {
  const { t } = useTranslation(["admin", "common"])
  const columns = useColumns()

  const [sorting, setSorting] = useState<SortingState>([
    { id: "createdAt", desc: true },
  ])

  const [isCreationModalOpen, setIsCreationModalOpen] = useDisclosure(false)
  const [selectedFAQ, setSelectedFAQ] = useState<FAQ | undefined>(undefined)

  const table = useCustomReactTable({
    data: faqs,
    columns,
    initialState: {
      pagination: {
        pageSize: DEFAULT_PAGE_SIZE,
      },
    },
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getPaginationRowModel: getPaginationRowModel(),
  })

  return (
    <Stack>
      <Group justify="right">
        <Button
          icon={<IconPlus />}
          onClick={setIsCreationModalOpen.toggle}
          variant="primary"
        >
          {t("faq.modal.create.title")}
        </Button>
      </Group>
      <CustomTable table={table} onRowClick={(row) => setSelectedFAQ(row)} />
      <FAQCreationModal
        opened={isCreationModalOpen}
        onClose={setIsCreationModalOpen.close}
      />
      {selectedFAQ && (
        <FAQEditionModal
          faq={selectedFAQ}
          onClose={() => setSelectedFAQ(undefined)}
        />
      )}
    </Stack>
  )
}
